import { Alert, Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H4, Image, LI, P, UL } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import useFourListe, { changeStatus, deleteProduit } from "./produitsApi";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { formatPhoneNumber, formatPrice, itemHasPermission, truncateText } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { Editor } from '@tinymce/tinymce-react';
import { Link } from "react-router-dom";

type Produit = { [key: string]: any }

const GestProduits = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Produit[]>([]);
    const [refresh, setRefresh] = useState(false);
    const prods = useFourListe(refresh) || [];
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [data, setData] = useState({
        libelle: '',
        prix_unitaire: 0,
        quantite_stock: 0,
        unite_de_mesure: '',
        valeur_par_tonnes: 0,
        id: null
    });
    const [erreur, setErreur] = useState({
        libelle: '',
        prix_unitaire: '',
        quantite_stock: '',
        unite_de_mesure: '',
        valeur_par_tonnes: '',
        id: null
    });

    useEffect(() => {
        const filtered = prods.filter((item) =>
            item.libelle && item.libelle.toLowerCase().includes(filterText.toLowerCase())
        );

        if (JSON.stringify(filtered) !== JSON.stringify(filteredItems)) {
            setFilteredItems(filtered);
        }
    }, [prods, filterText, filteredItems, refresh]);

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = data.id !== null ? `${URL_API}/produit/update/${data.id}` : `${URL_API}/produit/create`
        const Token = JSON.parse(localStorage.getItem("login")!);

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {
            if (response.status === 201) {
                const msg = data.id !== null ? "Produit modifié avec succès !!" : "Produit ajouté avec succès !!";
                toast.success(msg);
                clearDataForm();
            }
        }).catch(error => {
            console.log(error.response)
            if(error.response.status === 422){
                setErreur(error.response.data.message);
            }

            if (error.response.status == 405) {
                toast.info("Oups !! Erreur de modification des données");
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet element ??" : "De vouloir changer le status de cet element",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteProduit({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const editerData = ({ id }: { id: number }) => {
        const data = filteredItems.find((item) => item.id === id);
        if (data) {
            setData({
                libelle: data.libelle,
                quantite_stock: Number(data.quantite_stock),
                prix_unitaire: Number(data.prix_unitaire),
                unite_de_mesure: data.unite_de_mesure,
                valeur_par_tonnes: data.valeur_par_tonnes,
                id: data.id
            });
        } else {
            toast.info('Cet element de figure pas dans nos données')
        }

    }

    const clearDataForm = () => {
        setData({
            libelle: '',
            prix_unitaire: 0,
            quantite_stock: 0,
            unite_de_mesure: '',
            valeur_par_tonnes: 0,
            id: null
        });
        setErreur({
            libelle: '',
            prix_unitaire: '',
            quantite_stock: '',
            unite_de_mesure: '',
            valeur_par_tonnes: '',
            id: null
        });
    }

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Produits" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col md="8">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <Table responsive id="all-invoice" striped={true}>
                                <thead className="bg-info">
                                    <tr>
                                        <th className="text-white">Id</th>
                                        <th className="text-white">Libelle</th>
                                        <th className="text-white">Quantite</th>
                                        <th className="text-white">Prix Unitaire</th>
                                        {/* <th className="text-white">Nbr Ventes</th> */}
                                        {
                                            (itemHasPermission('super admin') || itemHasPermission('gest. magazin ecriture')) && (
                                                <>
                                                    <th className="text-white">Status</th>
                                                    <th className="text-white">Actions</th>
                                                </>
                                            )
                                        }

                                    </tr>
                                </thead>
                                <tbody>

                                    {filteredItems.length > 0 ? filteredItems.map((item, index) => (
                                        <tr key={item.id}>
                                            <th scope='row'>
                                                <span className="fw-bold">
                                                    #{index + 1}
                                                </span>
                                            </th>
                                            <td>
                                                <span className="fw-bold text-capitalize">
                                                    {item.libelle}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="fw-bold text-capitalize">
                                                    {parseFloat(item.quantite_stock.toLocaleString("gn-GN")) + " " + item.unite_de_mesure }
                                                </span>
                                            </td>
                                            <td>
                                                <span className="fw-bold text-capitalize">
                                                    {Number(item.prix_unitaire).toLocaleString("gn-GN")} GNF
                                                </span>
                                            </td>
                                            {/* <td>
                                                <span className="fw-bold text-capitalize">
                                                    {parseInt(item.vente_count).toLocaleString("gn-GN")}
                                                </span>
                                            </td> */}
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. magazin ecriture')) && (
                                                    <>
                                                        <td>
                                                            {item.status === 'disponible' || item.status === 'actif' ? (
                                                                <Btn className="btn btn-xs btn-light-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                    {item.status}
                                                                </Btn>
                                                            ) : (
                                                                <Btn className="btn btn-xs btn-light-danger" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                    {item.status}
                                                                </Btn>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <Link to={`/produits-show/${item.id}`} className='bg-info btn btn-xs mx-1 my-1'>
                                                                Details
                                                            </Link>
                                                            <Btn className='bg-dark btn-xs mx-1 my-1' onClick={() => editerData({ id: item.id })}>
                                                                <i className='fa fa-pencil'></i>
                                                            </Btn>
                                                            <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                <i className='fa fa-trash'></i>
                                                            </Btn>
                                                        </td>
                                                    </>
                                                )
                                            }

                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={7}>
                                                <Alert color="light-info" className="text-center">
                                                    <h4>Aucun Produit Trouvé</h4>
                                                </Alert>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                            {/* </div> */}
                        </Card>
                    </Col>
                    <Col md="4">
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmitData}>
                                    <H4 className="my-4 text-capitalize">
                                        {
                                            data.id == null ? ("Ajouter un produit") : ("Modification du produit " + data.libelle)
                                        }
                                    </H4>

                                    <div className="product-info">
                                        <div className="product-group">
                                            <Row>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Libelle</Label>
                                                        <Input
                                                            placeholder="Entrer le libelle"
                                                            name="libelle"
                                                            value={data.libelle}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.libelle && (
                                                            <span className="text-danger">{erreur.libelle}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Quantité en Stock</Label>
                                                        <Input
                                                            placeholder="Entrer la quantité stock"
                                                            name="quantite_stock"
                                                            value={data.quantite_stock}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.quantite_stock && (
                                                            <span className="text-danger">{erreur.quantite_stock}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Unités de mesure ou de reference</Label>
                                                        <Input
                                                            placeholder="Entrer l'unite de mesure ou de reference"
                                                            name="unite_de_mesure"
                                                            value={data.unite_de_mesure}
                                                            onChange={changeHandler}
                                                            type="text"
                                                        />
                                                        {erreur.unite_de_mesure && (
                                                            <span className="text-danger">{erreur.unite_de_mesure}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Valeur Correspondant au paquet ou la tonne</Label>
                                                        <Input
                                                            placeholder="Entrer l'unite de mesure ou de reference"
                                                            name="valeur_par_tonnes"
                                                            value={data.valeur_par_tonnes}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.valeur_par_tonnes && (
                                                            <span className="text-danger">{erreur.valeur_par_tonnes}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                                <Col sm="12">
                                                    <FormGroup>
                                                        <Label>Prix Unitaire par (<span className="fw-bold">{data.unite_de_mesure}</span>)</Label>
                                                        <Input
                                                            placeholder="Entrer le prix unitaire"
                                                            name="prix_unitaire"
                                                            value={data.prix_unitaire}
                                                            onChange={changeHandler}
                                                            type="number"
                                                        />
                                                        {erreur.prix_unitaire && (
                                                            <span className="text-danger">{erreur.prix_unitaire}</span>
                                                        )}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    {
                                        (itemHasPermission('super admin') || itemHasPermission('gest. magazin ecriture')) && (
                                            <div className="text-end">
                                                <Btn color="info" type="submit" disabled={isSubmitting}>
                                                    {data.id == null ? "Ajouter" : "Sauvegarder"}
                                                </Btn>
                                                <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                    Annuler
                                                </Btn>
                                            </div>
                                        )
                                    }

                                </Form>
                            </CardBody>

                        </Card>

                    </Col>
                </Row>
            </Container>
        </div>

    )
}

export default GestProduits